import { Component, OnInit, OnDestroy,ViewChild, ElementRef } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { Subscription } from 'rxjs/Subscription';

import { Restaurant } from './restaurant';

import { RestaurantService } from './restaurant.service';

import { MessageService }     from './message.service';

import 'rxjs/add/operator/switchMap';

import {BrowserModule, DomSanitizer} from '@angular/platform-browser';
declare var ga: Function;

@Component({
	selector: 'restaurant-book',
	templateUrl: './book.component.html',
	styleUrls: ['./book.component.css'],
	animations: [
    trigger('booking-form', [
            state('inactive', style({
                height: '0'
            })),
            state('active', style({
                height: '*'
            })),
            transition('inactive => active', animate('200ms ease-in')),
            transition('active => inactive', animate('200ms ease-out'))
        ])
	]
})

export class BookComponent implements OnInit, OnDestroy {

	subscription : Subscription;
	@ViewChild('booking_form') booking_form: ElementRef;

	constructor(
	 	private sanitizer: DomSanitizer,
		private m_restaurant_service: RestaurantService,
		private messageService: MessageService
  	) {
  		console.log("BookComponent constructor")
  		this.subscription = this.messageService.getMessage().subscribe(message => { 
	    	console.log("BookComponent received message");

	    	this.m_state = (this.m_state === 'inactive' ? 'active' : 'inactive');
	    });
  	}

	m_restaurant: Restaurant;
	m_state: string = 'inactive';
	name;path;bkurl;url;turl;bkextra;bktracking="WEBSITE";

	ngOnInit(): void {
		this.getRestaurant();
		this.bkurl = "http://localhost:8888/weeloy.com/restaurant/singapore/the-fun-kitchen/book-now";
		this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.bkurl); 
		 //ga('create', 'UA-127049971-1', 'auto', {storage: 'none','allowLinker': true});
		 //ga('require', 'linker');
      	 //ga('linker:autoLink', ['https://dev.weeloy.com'],false,true); 
      	//ga('send', 'pageview');
	
	}
	ngAfterViewInit() {
		console.log("IN AFTERVIEW INITI");
	}

	clickedShowHideBookingForm() {
		console.log("BookComponent clickedShowHideBookingForm")
        this.m_state = (this.m_state === 'inactive' ? 'active' : 'inactive');
    }

	getRestaurant(): void {
		console.log("BookComponent getRestaurant")
		this.m_restaurant_service.getRestaurant('SG_SG_R_TheFunKitchen').then(
			restaurant => {
				console.log("BookComponent callback")
				console.log("BookComponent callback restaurant: " + restaurant)
				console.log("BookComponent callback restaurant: " + restaurant.title)
				this.m_restaurant = restaurant
			}
		);
	}

   iframe_init(){
   	setTimeout(() => {
		if(typeof ga!=='undefined') {
		console.log("src", (<HTMLInputElement>document.getElementById('booking_form')).src);
          ga(function(tracker) {
	          window.localStorage.setItem('ga_clientId', tracker.get('clientId'));
	          var clientId = window.localStorage.getItem('ga_clientId');
	          var frameWindow = document.getElementById('booking_form')as HTMLIFrameElement;
	          var frameURL = 'https://www.restaurants.sg/modules/booking/book_form_section.php?bkrestaurant=SG_SG_R_TheFunKitchen&bktracking=WEBSITE';
	          //var frameURL = (<HTMLInputElement>document.getElementById('booking_form')).src;
	          console.log("DRAFT CLIENT ID ",tracker.get('clientId') );
	          console.log(" CONTENT WINDOW ",frameWindow.contentWindow);
	          frameWindow.contentWindow.postMessage(tracker.get('clientId'), frameURL);
          
        });
    }
	},1000);	

   }

	ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.subscription.unsubscribe();
    }
}


// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/book.component.ts